'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Suspense } from 'react';

function MJLoginContent() {
  const [mjUsername, setMjUsername] = useState('');
  const [mjPassword, setMjPassword] = useState('');
  const [mjLoading, setMjLoading] = useState(false);
  const [mjError, setMjError] = useState('');
  const mjRouter = useRouter();
  
  async function mjHandleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setMjLoading(true);
    setMjError('');
    
    try {
      const mjRes = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: mjUsername, password: mjPassword })
      });
      
      const mjData = await mjRes.json();
      
      if (mjData.success) {
        window.location.href = '/dashboard';
      } else {
        setMjError(mjData.error || '登录失败');
      }
    } catch {
      setMjError('网络错误，请重试');
    } finally {
      setMjLoading(false);
    }
  }
  
  return (
    <form onSubmit={mjHandleSubmit} className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">用户名</label>
        <input
          type="text"
          value={mjUsername}
          onChange={e => setMjUsername(e.target.value)}
          className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none"
          placeholder="请输入用户名"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">密码</label>
        <input
          type="password"
          value={mjPassword}
          onChange={e => setMjPassword(e.target.value)}
          className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none"
          placeholder="请输入密码"
          required
        />
      </div>
      
      {mjError && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
          {mjError}
        </div>
      )}
      
      <button
        type="submit"
        disabled={mjLoading}
        className="w-full py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors cursor-pointer"
      >
        {mjLoading ? '登录中...' : '登录'}
      </button>
      
      <div className="text-center text-sm text-gray-400">
        Design:小熊工作室
      </div>
    </form>
  );
}

function MJLoginPageInner() {
  const [mjInitStatus, setMjInitStatus] = useState<{ initialized: boolean; message: string } | null>(null);
  
  useEffect(() => {
    fetch('/api/init')
      .then(r => r.json())
      .then(d => {
        setMjInitStatus({ initialized: d.success, message: d.message });
      })
      .catch(() => {
        setMjInitStatus({ initialized: false, message: '无法连接服务器' });
      });
  }, []);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-white">
      <div className="w-full max-w-md p-8">
        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">学生档案出入库管理系统</h1>
            <p className="text-gray-500"></p>
            {mjInitStatus && (
              <p className={`mt-2 text-sm ${mjInitStatus.initialized ? 'text-green-600' : 'text-orange-500'}`}>
                {mjInitStatus.message}
              </p>
            )}
          </div>
          
          <Suspense fallback={<div className="text-center text-gray-500">加载中...</div>}>
            <MJLoginContent />
          </Suspense>
        </div>
      </div>
    </div>
  );
}

export default function MJLoginPage() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-white"><div className="text-gray-500">加载中...</div></div>}>
      <MJLoginPageInner />
    </Suspense>
  );
}